import api from "./client";

export const login = async (email, password) => {
  const response = await api.post("/api/v1/auth/login", { email, password });
  return response.data;
};

export const register = async (userData) => {
  const response = await api.post("/api/v1/auth/register", userData);
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get("/api/v1/auth/me");
  return response.data;
};

export const logout = () => {
  // Client-side logout only (remove token)
  localStorage.removeItem("franktech_token");
};
